<template>
  <div
    id="rStudioFooter"
    class="band"
  >
    <div class="bandContent">
      <div>
        <router-link :to="{ name: 'home' }">
          <div
            id="footerLogo"
            data-automation="footer-logo"
          />
        </router-link>
        <div
          id="versionInfo"
          data-automation="footer-version"
        >
          {{ version }}
        </div>
      </div>
      <div id="logos">
        <div id="copyright">
          © 2021 <a
            href="https://www.rstudio.com/"
            data-automation="footer-copyright"
            target="_blank"
            rel="noopener noreferrer"
          >RStudio, PBC</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'StandardFooter',
  computed: {
    ...mapState({
      version: state => state.status.version,
    }),
  },
}
</script>
